import React from 'react'
import { AiOutlineEnter } from 'react-icons/ai'

const EnterButton = ({ onClick }) => {
    return (
        <button onClick={onClick}>
            <AiOutlineEnter size={'1.5em'} />
        </button>
    )
}

export default EnterButton
